import { Button, Card, Divider, List, Tag, Typography } from 'antd';
import { useMemo } from 'react';
import { useGuardedNavigate } from '../../../app/providers/FormSafetyProvider';
import { useAuthSession } from '../../../app/providers/AuthSessionProvider';
import { ENABLE_AUTH } from '../../utils/constants';
import { canAccessPath } from '../../../app/router/accessControl';
import styles from './FlowAssistPanel.module.css';

const { Title, Paragraph, Text } = Typography;

export default function FlowAssistPanel({ flowMeta }) {
  const guardedNavigate = useGuardedNavigate();
  const { session } = useAuthSession();

  const visibleQuickActions = useMemo(
    () =>
      (flowMeta?.quickActions || []).filter((action) => {
        if (ENABLE_AUTH && !session) {
          return false;
        }

        return canAccessPath(action.path, session?.role, {
          enableAuth: ENABLE_AUTH,
          permissions: session?.permissions,
        });
      }),
    [flowMeta?.quickActions, session]
  );

  if (!flowMeta) {
    return null;
  }

  return (
    <Card className={styles.panel} variant="borderless">
      <Tag className={styles.tag}>{flowMeta.section}</Tag>
      <Title level={5} className={styles.title}>Need quick help?</Title>
      <Paragraph className={styles.summary}>{flowMeta.summary}</Paragraph>

      <Divider className={styles.divider} />

      <Text className={styles.label}>Useful tips</Text>
      <List
        className={styles.tipList}
        size="small"
        dataSource={flowMeta.tips || []}
        renderItem={(tip) => <List.Item className={styles.tipItem}>{tip}</List.Item>}
      />

      <Text className={styles.label}>Quick actions</Text>
      <div className={styles.actions}>
        {visibleQuickActions.map((action) => (
          <Button key={`${action.label}-${action.path}`} onClick={() => guardedNavigate(action.path)} block>
            {action.label}
          </Button>
        ))}
      </div>
    </Card>
  );
}
